import { createSlice } from '@reduxjs/toolkit';

export const limitModalSlice = createSlice({
    name: 'limitModal',
    initialState: {
        isOpen: false,
        subscriptionField: null,
    },
    reducers: {
        openLimitModal(state, action) {
            state.isOpen = true;
            state.subscriptionField = action.payload || null;
        },
        closeLimitModal(state) {
            state.isOpen = false;
            state.subscriptionField = null;
        },
    },
});

export const { openLimitModal, closeLimitModal } = limitModalSlice.actions;

export const selectLimitModal = (state) => state.limitModal;

export const limitModal = limitModalSlice.reducer;
